export const OWNER = {
  name: "Bilal N.",
  handle: "@thebilaldev0",
  role: "Senior Product Engineer",
  stack: "Bubble · React · TypeScript",
  location: "Bangalore, India",
  yearsExperience: 4,
  bio: "I build products from ideas — not just features. Over the last 4+ years, I've partnered with founders to take applications from concept to production, primarily using Bubble, and more recently contributing to React + TypeScript systems.",
  githubUsername: "thebilaldev0",
  email: "bilalmarazi0@gmail.com",
  whatsapp: "918699643670", // international format, no +
  whatsappDisplay: "+91 86996 43670",
  socials: {
    github: "https://github.com/thebilaldev0?tab=overview&from=2026-07-01&to=2026-07-07",
    linkedin: "https://www.linkedin.com/in/bilal-marazi/",
  },
};

export const SKILLS = [
  "BUBBLE.IO",
  "REACT",
  "TYPESCRIPT",
  "REST APIs",
  "WEBHOOKS",
  "MONGODB",
  "FIGMA",
  "POSTMAN",
  "ZOHO CRM",
  "SYSTEM DESIGN",
  "GIT",
  "JIRA",
];

export const PROJECTS = [
  {
    slug: "lumi",
    name: "LUMI",
    client: "Remotestar Ltd.",
    role: "Senior Product Engineer",
    years: "Oct 2024 — Jun 2026",
    kind: "SaaS Platform",
    summary:
      "End-to-end SaaS development, scaled the platform to 10,000+ users and led the migration from Bubble to React + TypeScript.",
    stack: ["Bubble", "React", "TypeScript", "Postgres"],
    accent: "#E3FF00",
    liveUrl: "https://platform.lumi.network/",
  },
  {
    slug: "feed64ck",
    name: "FEED64CK",
    client: "Remotestar Ltd.",
    role: "Senior Bubble Developer (Freelance)",
    years: "Jan 2026 — Jul 2026",
    kind: "Meeting Intelligence",
    summary:
      "Meeting-intelligence platform integrating Microsoft Graph + Teams. Built OAuth flow, async transcript pipelines, AI-powered conversation analytics and time-series performance dashboards. Access password ‘Feed64ck’.",
    stack: ["Bubble", "MS Graph", "OAuth", "AI"],
    accent: "#FF3B30",
    liveUrl: "https://interview-notetaker.bubbleapps.io/version-test/onboard",
  },
  {
    slug: "kagu",
    name: "KAGU",
    client: "Tenazx",
    role: "Senior Bubble Developer",
    years: "Jul 2024 — Sept 2024",
    kind: "Full-stack App",
    summary:
      "Full-stack build with third-party integrations, custom logic layer, complex business rules, and heavy SEO wins.",
    stack: ["Bubble", "Google cloud Platform", "Webhooks"],
    accent: "#00FFFF",
    liveUrl: null,
  },
  {
    slug: "sitekeep",
    name: "SITEKEEP",
    client: "WartinLabs",
    role: "Senior Product Developer",
    years: "Jan 2024 — Jul 2024",
    kind: "Product Suite",
    summary:
      "Led end-to-end development of Sitekeep, drove performance uplifts, and shipped BetterStoned's analytics + SEO stack.",
    stack: ["Bubble", "Analytics", "SEO", "Javascript"],
    accent: "#FF6EC7",
    liveUrl: null,
  },
  {
    slug: "expertrons",
    name: "EXPERTRONS",
    client: "Expertrons",
    role: "Bubble + Zoho Developer",
    years: "Aug 2023 — Jan 2024",
    kind: "Order Management",
    summary:
      "Built an order management system integrating Bubble with Zoho CRM using APIs, webhooks and MongoDB workflows.",
    stack: ["Bubble", "Zoho", "MongoDB", "Webhooks"],
    accent: "#E3FF00",
    liveUrl: null,
  },
];

// Placeholder project preview images (from design guidelines)
export const PROJECT_IMAGES = {
  lumi: "https://customer-assets.emergentagent.com/job_freelance-hub-575/artifacts/i7820k5g_Screenshot%202026-07-07%20at%206.56.12%E2%80%AFAM.png",
  "feed64ck": "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  kagu: "https://customer-assets.emergentagent.com/job_freelance-hub-575/artifacts/ozkx3smy_Screenshot%202026-07-07%20at%206.50.33%E2%80%AFAM.png",
  sitekeep: "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  expertrons: "https://images.pexels.com/photos/31622947/pexels-photo-31622947.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

// GitHub badges — placeholders the user can replace once he tells me the exact ones
export const GITHUB_BADGES = [
  { name: "pull-shark", label: "Pull Shark", color: "#E3FF00", desc: "Merged pull requests" },
  { name: "quickdraw", label: "Quickdraw", color: "#00FFFF", desc: "Closed within 5 min" },
  { name: "yolo", label: "YOLO", color: "#FF3B30", desc: "Merged without review" },
  { name: "pair-extraordinaire", label: "Pair Extraordinaire", color: "#FF6EC7", desc: "Co-authored commits" },
];

export const EXPERIENCE = [
  { years: "Oct 2024 — Jun 2026", role: "Senior Product Engineer (Bubble + React)", org: "Remotestar Ltd. — LUMI" },
  { years: "Jan 2026 — Jul 2026", role: "Senior Bubble Developer (Freelance)", org: "Remotestar Ltd. — Feed64ck" },
  { years: "Jul 2024 — Sept 2024", role: "Senior Bubble Developer (Freelance)", org: "Tenazx — Kagu" },
  { years: "Jan 2024 — Jul 2024", role: "Senior Product Developer", org: "WartinLabs Pvt Ltd" },
  { years: "Aug 2023 — Jan 2024", role: "Senior Bubble & Zoho Developer (Freelance)", org: "Expertrons" },
];

// Placeholder testimonials — swap real ones in when Bilal shares them
export const TESTIMONIALS = [
  {
    quote:
      "I worked with Bilal at Lumi.network for about a year and a half, where he was our mobile developer. ... He communicated clearly and kept things simple, so there was never any confusion about what needed to be done. He was easy going and warm, and this made working together enjoyable, not just productive.",
    author: "— Darius Fernandes",
    role: "Product Design & Delivery Manager, LUMI",
    accent: "#E3FF00",
  },
  {
    quote:
      "He rebuilt our backend workflows and cut our onboarding drop-off in half. Deep product thinking, not just execution.",
    author: "— David",
    role: "Founder, Feed64ck",
    accent: "#00FFFF",
  },
  {
    quote:
      "Rare mix of speed, taste, and rigor. Bilal shipped features I couldn't get 3 previous devs to close.",
    author: "— Naren",
    role: "CEO, Tenazx",
    accent: "#FF3B30",
  },
  {
    quote:
      "Works like an in-house senior. Owns problems end-to-end, communicates like a co-founder.",
    author: "— Saloni Goel",
    role: "Project Manager, Tenazx",
    accent: "#FF6EC7",
  },
];
